var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 4.98438L2.01562 1.23438C1.73438 0.929688 1.24219 0.929688 0.960938 1.23438C0.65625 1.51562 0.65625 2.00781 0.960938 2.28906L4.17188 5.5L0.960938 8.73438C0.65625 9.01562 0.65625 9.50781 0.960938 9.78906C1.10156 9.92969 1.28906 10 1.5 10C1.6875 10 1.875 9.92969 2.01562 9.78906L5.76562 6.03906C6.07031 5.75781 6.07031 5.26562 5.76562 4.98438ZM10.2656 4.98438L6.51562 1.23438C6.23438 0.929688 5.74219 0.929688 5.46094 1.23438C5.15625 1.51562 5.15625 2.00781 5.46094 2.28906L8.67188 5.5L5.46094 8.73438C5.15625 9.01562 5.15625 9.50781 5.46094 9.78906C5.60156 9.92969 5.78906 10 6 10C6.1875 10 6.375 9.92969 6.51562 9.78906L10.2656 6.03906C10.5703 5.75781 10.5703 5.26562 10.2656 4.98438Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow1.4cc530aa1d157c24f177e275afc8823b.svg";
export { ForwardRef as ReactComponent };